import React from 'react';

import { useTheme } from '../../hooks/useTheme';

import './theme-toggle.scss';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle">
      <span>
        {theme?.replace(
          /\w\S*/g,
          (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
        )}{' '}
        Mode
      </span>
      <div className="theme-toggle__container">
        <input
          type="checkbox"
          className="theme-toggle__checkbox"
          id="theme-checkbox"
          checked={theme === 'dark'}
          onChange={toggleTheme}
        />
        <label htmlFor="theme-checkbox" className="theme-toggle__label">
          {/* Moon SVG */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="theme-toggle__icon theme-toggle__icon--moon"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 1.992a10 10 0 1 0 9.236 13.838c.341 -.82 -.476 -1.644 -1.298 -1.31a6.5 6.5 0 0 1 -6.864
                    -10.787l.077 -.08c.551 -.63 .113 -1.653 -.758 -1.653h-.266l-.068 -.006l-.06 -.002z"
            />
          </svg>

          {/* Sun SVG */}
          <svg
            className="theme-toggle__icon theme-toggle__icon--sun"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="5" fill="currentColor" />
            <g stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </g>
          </svg>

          <span className="theme-toggle__ball" />
        </label>
      </div>
    </div>
  );
};

export default ThemeToggle;
